document.addEventListener("DOMContentLoaded", function () {

  const counters = document.querySelectorAll(".counter_text");

  function animateValue(start, end, duration, callback) {
    const startTime = performance.now();

    function update(currentTime) {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const value = start + (end - start) * progress;
      callback(value);

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      const el = entry.target;
      const raw = el.dataset.no;

      if (!raw) return;

      // Match all numbers (supports range)
      const numbers = raw.match(/[\d\.]+/g);
      if (!numbers) return;

      const duration = 1500;

      // if (entry.isIntersecting) {

      //   if (numbers.length === 1) {
      //     // Normal single number case
      //     const target = parseFloat(numbers[0]);
      //     const suffix = raw.replace(numbers[0], "");

      //     animateValue(0, target, duration, (val) => {
      //       el.textContent =
      //         (target % 1 !== 0 ? val.toFixed(1) : Math.floor(val)) + suffix;
      //     });

      //   } else if (numbers.length === 2) {
      //     // Range case like 2–4
      //     const startTarget = parseFloat(numbers[0]);
      //     const endTarget = parseFloat(numbers[1]);

      //     const prefix = raw.split(numbers[0])[0];
      //     const middle = raw.substring(
      //       raw.indexOf(numbers[0]) + numbers[0].length,
      //       raw.indexOf(numbers[1])
      //     );
      //     const suffix = raw.split(numbers[1])[1];

      //     animateValue(0, 1, duration, (progress) => {
      //       const firstVal = startTarget * progress;
      //       const secondVal = endTarget * progress;

      //       el.textContent =
      //         prefix +
      //         Math.floor(firstVal) +
      //         middle +
      //         Math.floor(secondVal) +
      //         suffix;
      //     });
      //   }

      // } else {
      //   // Reset when leaving view
      //   if (numbers.length === 1) {
      //     el.textContent = raw.replace(numbers[0], "0");
      //   } else if (numbers.length === 2) {
      //     el.textContent = raw.replace(numbers[0], "0").replace(numbers[1], "0");
      //   }
      // }
if (entry.isIntersecting && !el.classList.contains("counted")) {

  el.classList.add("counted"); // mark as animated

  if (numbers.length === 1) {

    const target = parseFloat(numbers[0]);
    const suffix = raw.replace(numbers[0], "");

    animateValue(0, target, duration, (val) => {
      el.textContent =
        (target % 1 !== 0 ? val.toFixed(1) : Math.floor(val)) + suffix;
    });

  } else if (numbers.length === 2) {

    const startTarget = parseFloat(numbers[0]);
    const endTarget = parseFloat(numbers[1]);

    const prefix = raw.split(numbers[0])[0];
    const middle = raw.substring(
      raw.indexOf(numbers[0]) + numbers[0].length,
      raw.indexOf(numbers[1])
    );
    const suffix = raw.split(numbers[1])[1];

    animateValue(0, 1, duration, (progress) => {
      const firstVal = startTarget * progress;
      const secondVal = endTarget * progress;

      el.textContent =
        prefix +
        Math.floor(firstVal) +
        middle +
        Math.floor(secondVal) +
        suffix;
    });
  }

  observer.unobserve(el); // 👈 stop observing after first run
}

    });
  }, { threshold: 0.5 });

  counters.forEach(counter => observer.observe(counter));

});